
    import { mapMutations } from 'vuex';
    import sassCommonVariables from '@/assets/sass/common/_common-variables.scss';
    import JobViewSplash from '@/components/JobView/JobViewSplash';
    import JobView from '@/components/JobView/JobView';
    import JobViewMixin from '@/components/JobView/Mixins/JobViewMixin';

    export default {
        components: {
            JobViewSplash,
            JobView,
        },

        mixins: [JobViewMixin],

        layout: 'discovery',

        async asyncData({ app, query, store, params, redirect, route }) {
            let isSplashOpen = false;
            if (query.utm_source && query.utm_source === 'affiliates') {
                isSplashOpen = false; // temporarily disable splash screen
            }

            const job = await store.dispatch('job/getJob', { jobUuid: params.id, createToken: true }).catch((e) => {
                if (e.response.status === 404) {
                    return redirect(301, { name: 'job-expired-id', params: { id: params.id } });
                }
            });
            let brand = {};
            if (store.state.job.job.brand_id) {
                const response = await store.dispatch('brand/getBrand', store.state.job.job.brand_id);
                if (response) {
                    store.commit('brand/STORE_BRAND', response.data);
                    brand = response.data;
                }
            }

            if (route.query.original_date) {
                store.commit('job/SHOW_ORIGINAL_POSTED_DATE');
            }

            if (store.state.me.user.id) {
                const attributeOptionAfterLogin = store.state.me.saveAttributionOptionAfterLogin;
                if (attributeOptionAfterLogin) {
                    const data = {
                        attribute_option_id: attributeOptionAfterLogin.attributeOption.id,
                    };
                    const attributeOption = await store.dispatch('me/attachAttribute', { id: attributeOptionAfterLogin.attributeId, data });
                    store.commit('me/PUT_ATTRIBUTE_OPTION', attributeOption.data);
                    store.commit('me/SAVE_ATTRIBUTE_OPTION_AFTER_LOGIN', '');
                }

                await Promise.all([store.dispatch('me/syncScoring'), store.dispatch('me/getJobEvents')]);
            }

            return {
                isSplashOpen,
                job,
                brand,
            };
        },

        data() {
            return {
                showCtaFlier: false,
                sassCommonVariables,
            };
        },

        head() {
            return {
                title: this.pageTitle,
                meta: this.metas,
                link: this.links,
                script: this.script,
            };
        },

        async created() {
            await this.$_UPDATE_JOB({ key: 'seeker_match_score', value: this.scoring });
        },

        mounted() {
            this.$nextTick(() => {
                window.addEventListener('scroll', this.handleScroll);
            });
        },

        beforeDestroy() {
            window.removeEventListener('scroll', this.handleScroll);
        },

        methods: {
            ...mapMutations('job', {
                $_UPDATE_JOB: 'UPDATE_JOB',
            }),

            onJobViewDestroy() {
                this.isSplashOpen = false;
            },

            handleScroll() {
                const jobview = this.$refs.jv;
                const jvHeaderEl = jobview.$refs.jvHeader.$el;
                this.showCtaFlier = this.isElementOutOfView(jvHeaderEl);
            },

            isElementOutOfView(element) {
                const elementTop = element.offsetTop;
                const elementHeight = element.offsetHeight;
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                const windowHeight = window.innerHeight || document.documentElement.clientHeight;
                const distanceFromTopToBottom = scrollTop + windowHeight;

                return distanceFromTopToBottom < elementTop || scrollTop > elementTop + elementHeight;
            },
        },
    };
